import React, { useState } from 'react';

const ChipSelect = ({ options, onChipSelect, question, values }) => {
  const [selectedChips, setSelectedChips] = useState(values || []);

  const handleChipClick = (index) => {
    setSelectedChips(prevChips => {
      if (prevChips.includes(index)) {
        return prevChips.filter(chip => chip !== index);
      } else {
        return [...prevChips, index];
      }
    });
  };

  return (
    <div>
      <div style={{ margin: '5px', color: '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px' }}>
        {question}
      </div>
      {options.map((option, index) => (
        <div
          key={index}
          onClick={() => handleChipClick(index)}
          style={{
            display: 'inline-block',
            margin: '4px',
            padding: '8px',
            borderRadius: '12px',
            border: '1px dashed #ccc',
            backgroundColor: selectedChips.includes(index) ? '#888' : '#fff',
            color: selectedChips.includes(index) ? '#fff' : '#000',
            cursor: 'pointer',
          }}
        >
          {option.persona_name}
        </div>
      ))}
    </div>
  );
};

export default ChipSelect;
